var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-250 -mt-20"},[_c('FormListPicker',{attrs:{"value":_vm.value[0] || null,"name":_vm.question.id,"data":_vm.orderedOptions,"hasError":_vm.hasError},on:{"input":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }